import React from 'react';
import { PropTypes } from 'prop-types';

const SearchHitCollege = ({ hit }) => (
    <div>
        <p style={{ fontSize: '18px', marginBottom: 0, lineHeight: '1.4em' }}>{hit.name}</p>
        <p style={{ fontSize: '14px', marginBottom: 0, color: '#343434' }}>
            {hit.state_name && hit.state_name}
            {hit.state_name && hit.country_name && ', '}
            {hit.country_name && hit.country_name}
        </p>
    </div>
);

SearchHitCollege.propTypes = {
    hit: PropTypes.object,
};

export default SearchHitCollege;
